module.exports = __webpack_public_path__ + "static/media/SPG_QR.4e226e0f.svg";